const Cities = {
  citiesPath: () => '/api/cities',
};

export default Cities;
